const SWATCH_SELECTOR = '.color-swatch[data-variant-swatch]';
const TOOLTIP_SELECTOR = '.swatch-tooltip';
const CARD_SELECTOR = '.product-card';
const EDGE_BUFFER = 4;

function positionSwatchTooltip(swatchButton) {
  const tooltip = swatchButton.querySelector(TOOLTIP_SELECTOR);
  if (!tooltip) return;

  const card = swatchButton.closest(CARD_SELECTOR);
  if (!card) return;

  if (swatchButton.dataset.tooltipPosition) {
    delete swatchButton.dataset.tooltipPosition;
  }

  const buttonRect = swatchButton.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();

  const buttonCenterX = buttonRect.left + buttonRect.width / 2;
  const tooltipHalfWidth = tooltipRect.width / 2;
  const projectedLeft = buttonCenterX - tooltipHalfWidth;
  const projectedRight = buttonCenterX + tooltipHalfWidth;

  if (projectedLeft < cardRect.left + EDGE_BUFFER) {
    swatchButton.dataset.tooltipPosition = 'left';
  } else if (projectedRight > cardRect.right - EDGE_BUFFER) {
    swatchButton.dataset.tooltipPosition = 'right';
  }
}

document.addEventListener(
  'pointerover',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const swatch = target.closest(SWATCH_SELECTOR);
    if (!swatch) return;
    positionSwatchTooltip(swatch);
  },
  { passive: true }
);

document.addEventListener(
  'focusin',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const swatch = target.closest(SWATCH_SELECTOR);
    if (!swatch) return;
    positionSwatchTooltip(swatch);
  },
  { passive: true }
);
